export default __webpack_public_path__ + "static/forgery_banner-22c69e21e3e3befd465d4f51ada8099f.jpg";